import { Injectable } from '@angular/core';
import { GoogleMapsAPIWrapper } from '@agm/core';

@Injectable()
export class GoogleMapsService {

    private wrapper: GoogleMapsAPIWrapper;

    constructor() {
        //
    }

    public getWrapper(): GoogleMapsAPIWrapper {
        return this.wrapper;
    }

    public setWrapper(wrapper: GoogleMapsAPIWrapper): void {
        this.wrapper = wrapper;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/google-maps.service.ts